import { render } from "./V2StoreListCarousel.vue?vue&type=template&id=6e45a76a&scoped=true"
import script from "./V2StoreListCarousel.vue?vue&type=script&lang=js"
export * from "./V2StoreListCarousel.vue?vue&type=script&lang=js"

import "./V2StoreListCarousel.vue?vue&type=style&index=0&id=6e45a76a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.33_vue@3.5.33_webpack@5.89.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e45a76a"]])

export default __exports__